export default __webpack_public_path__ + "static/media/close-icon-link.cb0ca1ff.svg";